import { omit } from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';
import { BE_OPTION_CONFIRMATION, VIRTUAL_PAGE_LOAD } from 'Tracking/constants';
import TrackingComponent from 'Tracking/tracking-component/TrackingComponent';
import { get as getStorageApi, set as setStorageApi } from 'Tracking/tracking-storage-api';
import { useSelector } from 'react-redux';
import { userInfoSelector } from 'Store/user-info/userInfo.selectors';
type Props = {
  trackingKey?: string;
  event?: string;
  track?: () => void;
  pageName?: string;
};
export const TrackingPageLoad = (props: Props) => {
  const {
    query: { trackingPageLoadAppendSuffix },
  } = useRouter();
  const profile: UserInfo = useSelector(userInfoSelector);

  function getTrackingProps() {
    let baseProps = {
      ...(props.trackingKey
        ? /**
           * We need to omit ski data because in case of 2 bookings from the same session,
           * when the first one has ski equipments and second one has none,
           * the second one get wrong ski data from locale storage
           * In case of new ski data exist, it will be added from props anyway
           */
          omit(
            (getStorageApi(props.trackingKey) || {}) as Record<string, unknown>,
            'skiEquipment',
            'skiingEquipment',
            'snowboardingEquipment',
            'hikingEquipment',
          )
        : {}),
      event: VIRTUAL_PAGE_LOAD,
      fidelityStatus: profile?.loyaltyProgram?.status || '',
      ...omit(props, 'children', 'location', 'history', 'match', 'trackingKey'),
    };

    if (trackingPageLoadAppendSuffix) {
      baseProps = {
        ...baseProps,
        pageName: `${baseProps.pageName}_${trackingPageLoadAppendSuffix}`,
      };
    }

    if (props.pageName === BE_OPTION_CONFIRMATION) {
      return omit(baseProps, [
        'upsellExcursion',
        'upsellRevenue',
        'donation',
        'paymentDeposit',
        'paymentMethod',
        'paymentPlan',
        'paymentStatus',
        'paymentType',
        'donation',
      ]);
    }

    return baseProps;
  }

  const trackingProps = getTrackingProps();
  React.useEffect(() => {
    if (props.event) {
      setStorageApi(trackingProps);
    }
  }, [props.event]);
  return <TrackingComponent {...trackingProps} track={props.track} />;
};
